import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative flex flex-col items-center justify-center text-center px-5 py-8 border-b-4 border-[#C0392B]" data-id="element-56">
      <div className="absolute inset-0 z-0" data-id="element-57">
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-black/82 z-10" data-id="element-58" />
        <img src="https://images.unsplash.com/photo-1513104890138-7c749659a591?w=1600" alt="" className="w-full h-full object-cover" data-id="element-59" />
      </div>

      <div className="relative z-10 max-w-4xl" data-id="element-60">
        <p className="text-[11px] tracking-[6px] text-[#F1C40F] mb-2 uppercase font-serif" data-id="element-61">
          🍕 El Código de la Pizza Pro
        </p>

        <div className="inline-block bg-[#C0392B] text-[#F1C40F] px-5 py-1 rounded-full font-bold tracking-[3px] mb-3 text-[8px]" data-id="element-62">
          EDICIÓN COMPLETA — 2 TOMOS + 5 BONOS
        </div>

        <h1 className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-[#F5F5F5] leading-tight mb-3 uppercase tracking-wider" data-id="element-63">
          Aprende a hacer la Pizza
          <br data-id="element-64" />
          <span className="text-[#C0392B]" data-id="element-65">Italiana Perfecta</span> en tu
          <br data-id="element-66" />
          <em className="text-[#F1C40F] not-italic" data-id="element-67">Horno de Casa</em>
        </h1>

        <div className="flex justify-center my-3" data-id="element-68">
          <img src="https://cdn.magicpatterns.com/uploads/b4j1KTkH3Dngi8KuC7hu5X/fa3d6e8f-03aa-45a6-b814-ab93e6dcd41e.png" alt="El Código de la Pizza Pro - Libro y Tablet" className="w-full max-w-xs sm:max-w-sm md:max-w-md h-auto object-contain drop-shadow-2xl brightness-110" style={{
          filter: 'brightness(1.15) contrast(1.05)',
          WebkitFilter: 'brightness(1.15) contrast(1.05)'
        }} data-id="element-69" />
        </div>

        <p className="text-xs sm:text-sm md:text-base text-[#F5F5F5] max-w-xl mx-auto mb-4 opacity-90 italic" data-id="element-70">
          El sistema completo con más de 50 recetas, técnicas de chef premiado y
          secretos que las pizzerías no quieren que sepas.
        </p>

        <motion.a href="#precio" className="inline-block bg-gradient-to-br from-[#C0392B] to-[#922B21] text-[#F1C40F] px-8 py-3 rounded-md text-base font-bold uppercase tracking-wider border-2 border-[#F1C40F] cursor-pointer" whileHover={{
        y: -3,
        scale: 1.02
      }} animate={{
        boxShadow: ['0 8px 30px rgba(192,57,43,0.5)', '0 8px 50px rgba(192,57,43,0.9)', '0 8px 30px rgba(192,57,43,0.5)']
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} data-id="element-71">
          ¡QUIERO MI COPIA AHORA!
        </motion.a>
        <span className="block text-[10px] text-[#F5F5F5] mt-1.5 tracking-wide opacity-80" data-id="element-72">
          ✅ Acceso inmediato · ✅ Descarga digital · ✅ Garantía incluida
        </span>
      </div>
    </section>;
}